import axios from 'axios'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  searchStocks({ commit }, params = {}) {
    return axios.get('/stocks/search', { params })
  },
  getStocks({ commit }, params = {}) {
    return axios.get('/stocks', { params })
  },
  getStock({ commit }, id) {
    return axios.get(`/stocks/${id}`)
  },
  getTransferStocks({ commit }, { transferId, params }) {
    return axios.get(`/transfers/${transferId}/stocks`, { params })
  },
  getStockReserved({ commit }, id) {
    return axios.get(`/stocks/${id}/reserved`)
  },
  updateStock({ commit }, data) {
    return axios.put(`/stocks/${data.id}`, data)
  },
  exportStockList({ commit }, params = {}) {
    return axios.get(`/stocks/export`, { params, responseType: 'blob' })
  }
}
